import React from 'react';
import { motion } from 'framer-motion';
import Section from '../../components/ui/Section';
import Button from '../../components/ui/Button';

const stats = [
  { value: '200+', label: 'transformierte Frauen' },
  { value: '6', label: 'Monate – echte Tiefe' },
  { value: '50k+', label: 'Community Reichweite' },
  { value: '98%', label: 'würden weiterempfehlen' },
];

const ManifestBanner = () => (
  <section className="relative py-24 overflow-hidden border-y border-white/5">
    {/* Cinematic ambient */}
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(212,175,55,0.06)_0%,transparent_70%)]" />
    <div className="absolute inset-0 bg-dark/90" />

    <div className="relative z-10 max-w-7xl mx-auto px-6">
      {/* Stats Row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
        {stats.map((s, i) => (
          <motion.div key={i}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ delay: i * 0.1 }}
            className="text-center"
          >
            <p className="text-4xl md:text-5xl font-serif text-gradient-gold mb-2"
              style={{ textShadow: '0 0 30px rgba(212,175,55,0.2)' }}>
              {s.value}
            </p>
            <p className="text-cream/50 text-sm uppercase tracking-widest font-light">{s.label}</p>
          </motion.div>
        ))}
      </div>

      {/* Manifesto line */}
      <motion.div initial={{ opacity: 0, scaleX: 0 }} whileInView={{ opacity: 1, scaleX: 1 }}
        viewport={{ once: true }} transition={{ duration: 1.5 }}
        className="w-full h-[1px] mb-20 origin-left"
        style={{ background: 'linear-gradient(to right, #D4AF37, rgba(212,175,55,0.1), transparent)' }}
      />

      <div className="flex flex-col md:flex-row justify-between items-center gap-10">
        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="text-4xl md:text-5xl lg:text-6xl font-serif text-cream max-w-2xl leading-tight">
          Du bist nicht hier, um zu <em className="text-wine-light">überleben.</em><br />
          Du bist hier, um zu <em className="text-gradient-gold">leuchten.</em>
        </motion.h2>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
          <Button variant="gold" className="whitespace-nowrap">GlücksCall buchen</Button>
        </motion.div>
      </div>
    </div>
  </section>
);

export default ManifestBanner;